import { render, staticRenderFns } from "./SourceBaseForm.vue?vue&type=template&id=594e10ca&scoped=true&"
import script from "./SourceBaseForm.vue?vue&type=script&lang=js&"
export * from "./SourceBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594e10ca",
  null
  
)

export default component.exports